import * as ReactService from "@intech/react-service";
import { EmpresaEntidade } from "../entidades/EmpresaEntidade";

class Empresa extends ReactService.BaseService {
  constructor() {
    super("Empresa");
  }

  Buscar = () =>
    this.CreateRequest<EmpresaEntidade[]>(ReactService.RequestType.GET, `Buscar`);

}

export const EmpresaService = new Empresa();
